import { useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
    getOverviewConnects
} from "actions/shopActions";
import Loading from "components/Loading";

const OverView = ({
    shop,
    getOverviewConnects,
}) => {
    const { t } = useTranslation();
    const { isLoading } = shop;
    const [data, setData] = useState(null);

    useEffect(() => {
        async function fetchData() {
            getOverviewConnects().then(async (d) => {
                if (d?.shopCount) {
                    setData(d)
                }
            });
        }
        fetchData();
    }, [getOverviewConnects]);


    return (
        <div className="card">
            <Loading isLoading={isLoading} />
            <div
                className="card-header rounded bgi-no-repeat bgi-size-cover bgi-position-y-top bgi-position-x-center align-items-start h-50px"
                style={{ backgroundImage: `url("${require("components/assets/media/custom/bg.jpg")}")` }}
            >
                <h3 className="card-title align-items-start flex-column text-white pt-2">
                    <span className="fw-bold fs-2x mb-3">Overview Connection</span>
                </h3>
            </div>
            <div className="card-body" style={{ backgroundImage: `url("${require("components/assets/media/custom/bg.jpg")}")` }}>
                <div className="mt-n20 position-relative">
                    <div className="row g-3 g-lg-6">
                        <div className="col">
                            <div className="bg-gray-100 bg-opacity-70 rounded-2 px-6 py-5  border-bottom border-danger h-100">
                                <div className="symbol symbol-30px me-5 mb-8">
                                    <span className="symbol-label">
                                        <i className="ki-outline ki-shop fs-1 text-primary" />
                                    </span>
                                </div>
                                <div className="m-0">
                                    <span className="text-gray-700 fw-bolder d-block fs-2qx lh-1 ls-n1 mb-1">
                                        {data?.shopCount || 0}
                                    </span>
                                    <span className="text-gray-500 fw-semibold fs-6">Total Connect Shop <Link to="/admin/shops">View {"->"}</Link></span>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="bg-gray-100 bg-opacity-70 rounded-2 px-6 py-5  border-bottom border-danger h-100">
                                <div className="symbol symbol-30px me-5 mb-8">
                                    <span className="symbol-label">
                                        <i className="ki-outline ki-shop fs-1 text-primary" />
                                    </span>
                                </div>
                                <div className="m-0">
                                    <span className="text-gray-700 fw-bolder d-block fs-2qx lh-1 ls-n1 mb-1">
                                        <span className="text-success">{data?.totalShopActiveCount || 0}</span> / <span className="text-danger">{data?.totalShopDieCount || 0}</span>
                                    </span>
                                    <span className="text-gray-500 fw-semibold fs-6">Number of <span className="text-success">Active</span> / <span className="text-danger">Die</span> shops <Link to="/admin/shops">View {"->"}</Link></span>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="bg-gray-100 bg-opacity-70 rounded-2 px-6 py-5 border-bottom border-danger h-100">
                                <div className="symbol symbol-30px me-5 mb-8">
                                    <span className="symbol-label">
                                        <i className="ki-outline ki-lots-shopping fs-1 text-primary" />
                                    </span>
                                </div>
                                <div className="m-0">
                                    <span className="text-gray-700 fw-bolder d-block fs-2qx lh-1 ls-n1 mb-1">
                                        {data?.totalShopPromotionCount || 0}
                                    </span>
                                    <span className="text-gray-500 fw-semibold fs-6">Total Connect Promotion <Link to="/admin/shops-promotion">View {"->"}</Link></span>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="bg-gray-100 bg-opacity-70 rounded-2 px-6 py-5 border-bottom border-danger h-100">
                                <div className="symbol symbol-30px me-5 mb-8">
                                    <span className="symbol-label">
                                        <i className="ki-outline ki-discount fs-1 text-primary" />
                                    </span>
                                </div>
                                <div className="m-0">
                                    <span className="text-gray-700 fw-bolder d-block fs-2qx lh-1 ls-n1 mb-1">
                                        {data?.totalActiveFlashSaleCount || 0}
                                    </span>
                                    <span className="text-gray-500 fw-semibold fs-6">Total Active Flash Sale <Link to="/admin/shops-promotion">View {"->"}</Link></span>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="bg-gray-100 bg-opacity-70 rounded-2 px-6 py-5  border-bottom border-danger h-100">
                                <div className="symbol symbol-30px me-5 mb-8">
                                    <span className="symbol-label">
                                        <i className="ki-outline ki-messages fs-1 text-primary" />
                                    </span>
                                </div>
                                <div className="m-0">
                                    <span className="text-gray-700 fw-bolder d-block fs-2qx lh-1 ls-n1 mb-1">
                                        {data?.totalShopMessageCount || 0}
                                    </span>
                                    <span className="text-gray-500 fw-semibold fs-6">Total Connect Message <Link to="/admin/shops-message">View {"->"}</Link></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = ({ shop }) => ({ shop });
const mapDispatchToProps = {
    getOverviewConnects
};

export default connect(mapStateToProps, mapDispatchToProps)(OverView);
